import React,{useState, useEffect, useRef} from 'react';
import {useHistory, useLocation} from 'react-router-dom'
import {getPostById} from '../../services/servicesGetPostById';
import {unlockPost} from '../../services/servicesUnlockPost';
import {getMyPostsIds} from '../../services/servicesGetMyPostsIds';
import {getMyPostsById} from '../../services/servicesGetMyPostsById';
import {PostSaveMyPost} from '../../services/servicesPostSaveMyPost';
import {GetFBIGToken} from '../../services/servicesGetFBIGToken';
import {Post,
    DivMain,
    Button,
    SpanButton,
    TextAreaBlockedPost,
    DivPaiImage,
    DivImg,
    DivImgLiberado,
    ImgLiberado,
    ImgBloqueada,
    LabelImageEditPost,
    TituloPost,
    InputTituloPost,
    DivTextPost,
    TextAreaTextPost,
    P,
    Divoption,
    Option,
    DivReleasePost,
    DivTextoBloqueado,
    DivPaiImagePostLiberado,
    DivButton,
    DivCompartilharSocial,
    InstagramBusiness,
    Button2,
    DivBotoes,
    DivSelecaoInstagramBusiness,
    ImgInstagramBusiness,
    ImgPerfilPreview,
    ImgPostsPreviewInstagram,
    DivMainPreviewInstagram,
    SpanContextPost} from './stylePostEdit';
import {IconAiOutlineInstagram, IconAiOutlineFacebook} from './stylePostEdit';
import {DivPopupBannedList, DivCorfirm, DivButtonOption} from '../newPost/newPostStyle';
import Popup from "reactjs-popup";
import Toastify from '../../components/Toastify';
import InputFile from '../../components/inputs/inputFile/InputFile';
import {IconMdBorderColor} from '../../components/menu/styles';
import LoadScreen from '../../components/loadScreen/loadScreen'
import FB from '../../helpers/fb';
import {GetPostsLeft} from '../../services/servicesGetPostsLeft';
import { Subscribe } from '../../services/servicesSubscribe';
import {URLIMG} from '../../helpers/constantes';
import api from '../../services/apiFacebook';
import EditorImage from '../../components/editorImage/editorImage';
import LoadScreenSmall from '../../components/loadScreenSmall/loadScreenSmall';
import ButtonTrialVersion from '../../components/ButtonTrialVersion/ButtonTrialVersion';
import {getCheckPost} from '../../services/servicesCheckPost'

export default function PostEdit(props){
    //states abertura de popup
    const location = useLocation();
    const history = useHistory();
    const [smallScreen, setSmallScreen] = useState(false);
    const [liberaPost, setLiberaPost] = useState(false);
    const [renovacao, setRenovacao] = useState(false);
    const [popupSelecaoInstagram, setPopupSelecaoInstagram] = useState(false);
    const [editorImage, setEditorImage] = useState(false);
    const [loadScreen, setLoadScreen] = useState(false);
    const [selectSocialMidia, setSelectSocialMidia] = useState(false);
    const [previewPostInstagram, setPreviewPostInstagram] = useState(false);
    const [popupVerifyText, setPopupVerifyText] = useState(false);
    const [popupVerifyTextShare, setPopupVerifyTextShare] = useState(false);
    //fim states abertura de popup

    const [idDoPost, setIdDoPost] = useState('');
    const [popUpLiberaPost, setPopUpLiberaPost] = useState(false);
    const [fotoCarregada, setFotoCarregada] = useState(true);
    const [qntdPostLeft, setQntdPostLeft] = useState('');
    const [instagramProfileData, setInstagramProfileData] = useState({});
    const [bannedWordList, setBannedWordList] = useState({})
    const refImagePost = useRef();
    const reflayerTitlePost = useRef();
    const refTitlePost = useRef();
    const reflayerTextPost = useRef();
    const refTextPost = useRef()
    let editaTitle = false;
    let editaText = false;
    //teste de compartilhamento
    const [dadosInstagram, setDadosInstagram] = useState([]);
    function fechaPopupSelecaoInstagram (){
        setPopupSelecaoInstagram(false)
    }
    //fim teste de compartilhamento

    const [conteudoPost, setConteudoPost] = useState({Id:'',
    Image1:'',
    PostText:'',
    PostTitle:'',
    Category:'',
    Date:'',
    PopularCount:'',
    KeyWords:'',
    PostURL:''})
//configuração do toastify
    const customId  = 'custom-id-yes';
    const Sucess = () => Toastify.success('Salvo com Sucesso',{toastId:customId} );
    const Error = (mensagem) => Toastify.error(mensagem,{toastId:customId});

//fim configuração do toastify

//estilização inline
    const styleSecondDiv = {
        height:'100%',
        width:window.screen.width > 800 ?'50%':'100%',
        overflow:'hidden',
        marginLeft:window.screen.width > 800 ?'20px':'0',
        borderRadius: '0px 0px 5px 5px'
    }
    const styledPopupSelectMidiaSocial = {
        width:'fit-content',
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        padding:'20px',
        borderRadius:'8px'
    }
    const styledPopupLoadscreen = {
        width:'100vw',
        height:'100vh',
        backgroundColor:'RGBA(0,0,0,0.1)',
        display:"flex",
        justifyContent:'center',
        alignItems:'center'
    }
//fim estilização inline

    useEffect(() => {
        const newId = window.location.href.split('/');
        setIdDoPost(newId[newId.length - 1])
        carregaPost(newId[newId.length - 1]);
        verificaDesbloqueio(newId[newId.length - 1]);
        pegaInstagramBusiness();
        verificaQuantidadeDePosts();
    }, [location]);

    useEffect(()=>{
            // console.log(conteudoPost.Image1)
            setConteudoPost({...conteudoPost,Image1:conteudoPost.Image1});
    },[conteudoPost.Image1]);

    async function verificaQuantidadeDePosts(){
        const result = await GetPostsLeft();
        setQntdPostLeft(result)
    }
    async function verificaDesbloqueio(idDoPost){
        const templateId = await getMyPostsIds();
        //verifica se templateID já foi utilizado false = não ; true = sim
        let verify = false;

        templateId.map((item)=>{
            if(item.PostTemplateId.toString() === idDoPost){
                verify = true;
            }
        })
        if(verify){
            Toastify.warning('Post já desbloqueado');
            history.goBack();

        }
    }
    async function generateTicket(){
        setSmallScreen(true);
        const ticketLink = await Subscribe();
        window.location.href = `${ticketLink}&redirectURL=https://social.medx.med.br/payment-success`;
        setSmallScreen(false);
    }
    async function carregaPost(number)
    {
        // debugger
        //verifica se o post clicado vem da pgina de myposts ou de qualquer outro lugar
        if(typeof(props.location.state) != "undefined" && props.location.state.pagePreview === "myposts"){
            const resultPosts = await getMyPostsById(number);
            // debugger
            if(resultPosts != null){
                // debugger
                setConteudoPost({
                    ...conteudoPost,
                    Category:resultPosts[0].Category,
                    Date:resultPosts[0].Date,
                    Id:resultPosts[0].Id,
                    Image1:`${URLIMG+resultPosts[0].Image1.split('/')[resultPosts[0].Image1.split('/').length - 1]}`,
                    KeyWords:resultPosts[0].KeyWords,
                    PopularCount:resultPosts[0].PopularCount,
                    PostText:resultPosts[0].PostText,
                    PostTitle:resultPosts[0].PostTitle,
                    PostURL : resultPosts[0].PostURL},
                )

                setLiberaPost(true);
            }
            else{
                Error('Não foi possível carregar location state null');
                return
            }
         }else{
            const resultPosts = await getPostById(parseInt( number));
            if(resultPosts.length > 0 ){
                setConteudoPost({
                    ...conteudoPost,
                    Category:resultPosts[0].Category,
                    Date:resultPosts[0].Date,
                    Id:resultPosts[0].Id,
                    Image1:`${URLIMG+resultPosts[0].Image1.split('/')[resultPosts[0].Image1.split('/').length - 1]}`,
                    KeyWords:resultPosts[0].KeyWords,
                    PopularCount:resultPosts[0].PopularCount,
                    PostText:resultPosts[0].PostText,
                    PostTitle:resultPosts[0].PostTitle,
                    PostURL : resultPosts[0].PostURL},
                )
            }else{
                const resultPosts2 = await getMyPostsById(parseInt( number));
                if(resultPosts2.length > 0  ){
                    setLiberaPost(true);
                    setConteudoPost({
                        ...conteudoPost,
                        Category:resultPosts2[0].Category,
                        Date:resultPosts2[0].Date,
                        Id:resultPosts2[0].Id,
                        Image1:`${URLIMG+resultPosts2[0].Image1.split('/')[resultPosts2[0].Image1.split('/').length - 1]}`,
                        KeyWords:resultPosts2[0].KeyWords,
                        PopularCount:resultPosts2[0].PopularCount,
                        PostText:resultPosts2[0].PostText,
                        PostTitle:resultPosts2[0].PostTitle,
                        PostURL : resultPosts2[0].PostURL},
                    )
                }
            }
        }
    }
    async  function liberarPost(){
        try{
            const leftPost = await GetPostsLeft();
            if(leftPost > 0){
                const resposta = await unlockPost(idDoPost);
                // debugger
                if(resposta.status == 200){
                    setLiberaPost(true);
                    setConteudoPost({...conteudoPost,Id:resposta.data});
                    setPopUpLiberaPost(false);
                    location.pathname = `/app/postedit/${resposta.data}`
                }else{
                    Error('Não foi possível liberar o post')
                    setPopUpLiberaPost(false);
                }
            }else{
                setPopUpLiberaPost(false);
                setQntdPostLeft(leftPost);
                setRenovacao(true);
            }
       }catch(error){
        setPopUpLiberaPost(false);
        Error('Não foi possível liberar o post')
       }

    }
    function editaTexto(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostText:event.target.value});
    };
    function editaTitulo(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostTitle:event.target.value});
    };
   async function salvarPost(){
        try {
            setPopupVerifyText(false);
            setSmallScreen(true);
            const salvandoPost = await PostSaveMyPost(conteudoPost);
            if (salvandoPost.status !== 400 && salvandoPost.data.Status !== "Error"){
                setSmallScreen(false);
                Sucess();
            }else
                setSmallScreen(false);
                Error("Não foi possível salvar o post");
        } catch (error) {
                setSmallScreen(false);
                Error('Não foi possível salvar o post catch');
        }

    }
    function pegaInstagramBusiness(){
        const instagramBusiness = false;
        if(instagramBusiness)
            setDadosInstagram(instagramBusiness);
    }
    async function compartilhaInstagram(idInstagramBusiness){
        setPreviewPostInstagram(false);
        setSmallScreen(true);
        const tokenAcess = await GetFBIGToken();
        if(conteudoPost.PostText.length < 2200){
            try {
                const midia = await api.post(`${idInstagramBusiness}/media?image_url=${conteudoPost.Image1}&caption=${encodeURIComponent(conteudoPost.PostText)}&access_token=${tokenAcess.data}`);
                const postagem = await api.post(`${idInstagramBusiness}/media_publish?creation_id=${midia.data.id}&access_token=${tokenAcess.data}`);
                setSmallScreen(false);
                if(postagem.data.id){
                    setPopupSelecaoInstagram(false);
                    Toastify.success('Compartilhada com sucesso');
                }else{
                    Toastify.error('Erro ao fazer a publicação')
                }
            } catch (error) {
                setSmallScreen(false);
                Toastify.error('Erro ao realizar o compartilhamento');
            }
        }else{
            setPopupSelecaoInstagram(false);
            setSmallScreen(false);
            Toastify.error('Quantidade caracteres acima de 2200');
        }
    }
    async function getInstagramData(idInstagramBusiness){
        try {
            setSmallScreen(true);
            const tokenAcess = await GetFBIGToken();
            const {data,status} = await api.get(`${idInstagramBusiness}?fields=biography,name,profile_picture_url,media,media_count,followers_count,follows_count,username&access_token=${tokenAcess.data}`);
            if(status === 200){
                const loadMidiaEnded = []
                await Promise.all( data.media.data.map(async (item)=>{
                    const {data} = await api.get(`${item.id}?fields=media_url,timestamp&access_token=${tokenAcess.data}`);
                    loadMidiaEnded.push(data)
                }))
                loadMidiaEnded.sort((a,b)=> new Date(b.timestamp) - new Date(a.timestamp));
                setInstagramProfileData({data,urls:loadMidiaEnded});
                setSmallScreen(false);

            }else{
                Toastify.error('Erro ao carregar dados do perfil')
            }
        } catch (error) {
            console.error(error);
            Toastify.error('Não foi possível carregar o perfil');
            setSmallScreen(false);
        }
    }
    async function getAllInstagram(facebook_page_id, token_page_facebook) {
            const data = await api.get(`${facebook_page_id}?fields=instagram_accounts{id,profile_pic,username}&access_token=${token_page_facebook}`)
            if (data.status ===200){
                return data.data
            }else{
                return 400;
            }
    }
    async function selectInstagramBusiness(){
        try{
            setSmallScreen(true);
            const token = await GetFBIGToken();
            // const token = localStorage.getItem('token_acess');
            if(token){
                const instagramData = await api.get( `me/accounts?fields=instagram_business_account{username,profile_picture_url}&access_token=${ token.data }` );
                // if(localStorage.getItem('accounts')){
                //     const data = JSON.parse(localStorage.getItem('accounts'));
                //     const allInstagram = []
                //     if  (data?.accounts?.data){
                //         for (let index = 0; index <  data.accounts.data.length; index++) {
                //             const element =  data.accounts.data[index];
                //             const instagram = await getAllInstagram(element.id,element.access_token);
                //             instagram.instagram_accounts.data.map(item=>{
                //                 allInstagram.push(item);
                //             })
                //         }
                //     console.log(allInstagram);
                //     debugger
                //     }
                //     const obj_id_acessToken_instagram = data.accounts.data.map(item => {
                //         console.log(item.id)
                //         console.log(item.access_token)
                //     })

                //     debugger
                //     // const instagram = await api.get(`{instagram_id}?fields=instagram_accounts&access_token={token_page_facebook}`);
                // }
                if(instagramData.data.data.length > 0){
                    setDadosInstagram(instagramData.data)
                    setTimeout(() => {
                        setSelectSocialMidia(false);
                        setPopupSelecaoInstagram(true);
                        setSmallScreen(false);
                    }, 500);

                    return;
                }else{
                    setSmallScreen(false);
                    Toastify.warning('Nenhuma conta business associada ao facebook conectado')
                }
            }else{
                    setSmallScreen(false);
                    Toastify.error('Erro ao carregar token');
            }
        }catch(error){
            debugger
            console.log(error);
            setSmallScreen(false);
             salvarPost();
                Toastify.error('Não foi possível conectar ao instagram');
                history.push('/');
                location.pathname = '/'
                document.location.reload()
        }

    }
    async function openPreviewInstagram(idInstagramBusiness){
        setSmallScreen(true);
        await getInstagramData(idInstagramBusiness)
        await setPopupSelecaoInstagram(false);
        await setPreviewPostInstagram(true);
        setSmallScreen(false)
    }
    async function verifyText(text, localfunction , salvar){
        try {
            setSmallScreen(true);
            if(text.length < 2000){
                const data = await getCheckPost(text.toString());
                if(data.data.length > 0){
                setBannedWordList(data.data);
                salvar?setPopupVerifyText(true):setPopupVerifyTextShare(true);
                setSmallScreen(false);
                }else{
                    setSmallScreen(false);
                    localfunction();
                }
            }else{
                Toastify.warning('O texto excede o limite de 2000 caracteres')
                setSmallScreen(false);
            }

        } catch (error) {
            console.log(error);
            setSmallScreen(false);
        }
    }
    function mountBannedList(array_word_list){
        if(array_word_list.length > 0)
        return array_word_list.map((item,index) =><div key={index} style={{margin:'10px 0 20px 0', borderBottom:'1px solid lightgrey',padding:'0 0 10px 0'}}><span style={{fontSize:'26px'}}><b>{item.Phrase}</b></span><br /><span style={{fontSize:'18px'}} >{item.Explanation}</span></div>)
    }
    function selectSocialMedia(){
        setPopupVerifyTextShare(false);
        setSelectSocialMidia(true)
    }
    return(<DivMain>
        <ButtonTrialVersion />
    <Post>
        <DivPaiImage>
            {liberaPost ?
                <DivPaiImagePostLiberado>
                    <div style={{height:'40px',marginBottom:'20px', display:'flex',justifyContent:'space-evenly'}}>
                        <InputFile mudaImg = {setConteudoPost}
                            imagem={conteudoPost}
                            load={fotoCarregada}
                            concluido={setFotoCarregada}/>
                        <Button2 onClick={()=>setEditorImage(true)} >
                            <DivCompartilharSocial responsive={true}>
                                <span>Utilizar Editor</span>
                            </DivCompartilharSocial>
                        </Button2>
                    </div>
                    <DivImg style={{overflow:'hidden'}}>
                        <DivImgLiberado>
                            {fotoCarregada?
                                <ImgLiberado
                                ref={refImagePost}
                                draggable={false}
                                // onError={(event)=>{carregaUrlCorreta(event.currentTarget)}}
                                id='canvas' src={conteudoPost.Image1} />
                            :
                                <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                            }
                            <LabelImageEditPost htmlFor='FotoEditaPost'style={{position:'relative',bottom:'calc(100vh * 0.35)',height:'0'}}>
                                <IconMdBorderColor style={{fontSize:'40pt'}}/>
                            </LabelImageEditPost>
                        </DivImgLiberado>
                    </DivImg>
                </DivPaiImagePostLiberado>
            :
                <DivImg  style={{background:'lightgray'}}>
                    <ImgBloqueada
                    // onError={(event)=>{carregaUrlCorreta(event.currentTarget)}}
                    id='divimage' alt='' src={conteudoPost.Image1}/>
                </DivImg>
            }
        </DivPaiImage>
        <div style={styleSecondDiv}>
        {liberaPost ?
            <DivBotoes >
                <Button onClick={()=> verifyText(conteudoPost.PostText,salvarPost,true) }>
                    {/* ()=> verifyText(conteudoPost.PostText,salvarPost,true)                    }> */}
                    <SpanButton>Salvar</SpanButton>
                </Button>
                <Button onClick={()=>verifyText(conteudoPost.PostText,setSelectSocialMidia(true),false)}>
                    <SpanButton>Compartilhar</SpanButton>
                </Button>
            </DivBotoes>
        :   <DivReleasePost >
                <Button onClick={()=>{setPopUpLiberaPost(true)}}>
                        <SpanButton>Liberar Post</SpanButton>
                </Button>
            </DivReleasePost>
        }
            {liberaPost ?
                <div style={{margin:'20px 0 0 0'}}>
                    <div style={{display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=>refTitlePost.current.focus()}>
                        <IconMdBorderColor style={{margin:'0 12px 0 0'}}/>
                        <SpanContextPost>Edite o título do post</SpanContextPost>
                    </div>
                    <InputTituloPost
                        ref={refTitlePost}
                        value={conteudoPost.PostTitle}
                        onChange={(event)=>{editaTitulo(event)}}
                        maxLength='250'
                    />
                </div>
            :
                <TituloPost>
                    {conteudoPost.PostTitle}
                </TituloPost>
            }

            <DivTextPost id='divtextpost' style={liberaPost ? {background:'#F0F2F5'}:{background:'lightgray'}}>
                {liberaPost ?
                    <div style={{width:"100%",height:'100%'}} >
                        <div style={{display:'flex',alignItems:'center',cursor:'pointer'}} onClick={()=>refTextPost.current.focus()} >
                            <IconMdBorderColor style={{margin:'0 12px 0 0'}}/>
                            <SpanContextPost>Edite o texto do post</SpanContextPost>
                         </div>
                        <TextAreaTextPost
                            ref={refTextPost}
                            value={conteudoPost.PostText}
                            maxLength='2200'
                            onChange={(event)=>{editaTexto(event)}}
                            onBlur={()=>editaText = false}
                        />
                    </div>
                :
                    <DivTextoBloqueado style={{background:'lightgray'}}>
                       <TextAreaBlockedPost type='text' unselectable='on' readOnly disabled draggable={false}   >
                        {conteudoPost.PostText}
                       </TextAreaBlockedPost>
                    </DivTextoBloqueado>
                }
            </DivTextPost>
        </div>
    </Post>

        <Popup open={popUpLiberaPost} onClose={() => setPopUpLiberaPost(false)} modal
            contentStyle={{
            borderRadius:'4px',
            width: "60vh",
            padding:'10px',
            boxShadow: "1px 0px 39px 5px rgba(31,26,31,1)" }}
        >
            <div>
                <P>{`Deseja desbloquear o post ? Isso irá consumir 1 post do seu saldo de ${qntdPostLeft}. Essa ação não poderá ser desfeita.`}</P>
                <Divoption >
                    <Option onClick={()=> liberarPost() }>Sim</Option>
                    <Option onClick={() => setPopUpLiberaPost(false)}>Não</Option>
                </Divoption>
            </div>
        </Popup>
        <Popup open={renovacao} onClose={()=>setRenovacao(false)} modal closeOnDocumentClick={false}
             contentStyle={{height:'content-fit',
                 width:'content-fit',
                 borderRadius:'4px',
                padding:'10px'}}
        >
            <div style={{display:'flex',flexDirection:'column',lineHeight:'35px'}}>
                    <P style={{margin:'0'}}>Sua quantidade de posts é: {qntdPostLeft}</P>
                    <P style={{margin:'0'}}>Deseja renovar a contratação de posts ?</P>
                    <Divoption style={{marginTop:'15px'}}>
                       <Option onClick={generateTicket} >Sim</Option>
                        <Option onClick={()=>{setRenovacao(false)}}>Não</Option>
                    </Divoption>
                </div>
        </Popup>
        <Popup open={popupSelecaoInstagram} onClose={fechaPopupSelecaoInstagram} contentStyle={{width:'unset',borderRadius:'10px'}} closeOnDocumentClick={false} >
                <DivSelecaoInstagramBusiness >
                    <h1>Selecione o instagram</h1>
                    <div style={{display:'flex'}} >
                        { dadosInstagram?.data?.map(item =>
                        item.instagram_business_account ?
                        <InstagramBusiness
                            onClick={ ()=> openPreviewInstagram(item?.instagram_business_account?.id) }
                            key={item?.instagram_business_account?.id}>
                                <img alt='' src={item?.instagram_business_account?.profile_picture_url}/>
                                <span>{ item?.instagram_business_account?.username }</span>
                            </InstagramBusiness>:''
                        )}
                    </div>
                <Button onClick={fechaPopupSelecaoInstagram} ><SpanButton>Cancelar</SpanButton> </Button>
                </DivSelecaoInstagramBusiness>
        </Popup>
        <Popup open={ editorImage } onClose={()=>setEditorImage(false)} closeOnDocumentClick={false} closeOnEscape={false} contentStyle={{backgroundColor:'#1E1E1E',borderColor:'#1E1E1E',borderRadius:'4px',width:'fit-content',height:'fit-content'}}>
                <EditorImage text={conteudoPost.PostTitle} image={conteudoPost.Image1} exibe={setConteudoPost} close={setEditorImage} save={salvarPost} loadScreen={setLoadScreen}/>
        </Popup>
        <Popup open={loadScreen} onClose={()=>setLoadScreen(false)} contentStyle={styledPopupLoadscreen}  >
                <div style={{position:'absolute',width:'70vw', height:'80vh'}} >
                    <LoadScreen  background='unset' position='unset'/>
                </div>
        </Popup>
        <Popup open={ selectSocialMidia } onClose={ ()=> setSelectSocialMidia(false) } closeOnDocumentClick={false} contentStyle={styledPopupSelectMidiaSocial}>
                <div style={{display:'contents'}}>
                    <div style={{margin:'0 0 20px 0'}}>
                        <FB url={'https://social.medx.med.br/sites/' + JSON.parse(localStorage.getItem('currentUser')).AliasFolder + '/' + conteudoPost.PostURL}
                            texto={conteudoPost.PostText}
                            children = { <IconAiOutlineFacebook style={ { margin:'0 40px 0 0' } } /> } />
                        <IconAiOutlineInstagram onClick={selectInstagramBusiness} />
                    </div>
                    <div>
                        <Button onClick={()=>setSelectSocialMidia(false)}>
                            <SpanButton>Cancelar</SpanButton>
                        </Button>
                    </div>
                </div>
        </Popup>
        <Popup open={previewPostInstagram} onClose={ ()=> setPreviewPostInstagram(false) } contentStyle ={{width:window.screen.width < 800?'100vw':'50%'}}>
            <DivMainPreviewInstagram>
                <div style={{display:'flex', justifyContent:'space-evenly', margin:'0 0 20px 0',height:'40px'}}>
                    <Button onClick={()=> compartilhaInstagram(instagramProfileData?.data?.id) } >
                        <SpanButton>Compartilhar</SpanButton>
                    </Button>
                    <Button onClick={()=>{setPreviewPostInstagram(false)}} >
                        <SpanButton>Cancelar</SpanButton>
                    </Button>
                </div>
                <div style={{ display:'flex', overflow:'auto',flexDirection:'column',height:'calc(100% - 40px)', padding:'0 0 40px 0' }} >
                    <div id='headerPreviewInstagram' style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <div id='headerLogo' style={{display:'flex', flexDirection:'column', padding:'20px',textAlign:'center'}}>
                            <ImgPerfilPreview src={instagramProfileData?.data?.profile_picture_url} />
                            <span>{instagramProfileData?.data?.name}</span>
                        </div>
                        <div id='infoInsta' style={{display:'flex', alignItems:'center',flexDirection:'column',justifyContent:'center', margin:'0 0 0 30px'}}>
                            <span>seguindo:{instagramProfileData?.data?.follows_count}</span>
                            <span>seguidores:{instagramProfileData?.data?.followers_count}</span>
                        </div>

                    </div>
                    <div style={{display:'flex', flexWrap:'wrap', justifyContent:'center'}}>
                        <ImgPostsPreviewInstagram src={conteudoPost.Image1} alt='' />
                    {
                        instagramProfileData?.urls?.map(item=>{
                            return <ImgPostsPreviewInstagram key={item.id} src={item.media_url}  alt=''/>
                        })
                    }
                    </div>
                </div>
            </DivMainPreviewInstagram>
        </Popup>
        <Popup open={popupVerifyText} onClose={()=> setPopupVerifyText(false)} contentStyle={{width:'fit-content'}} >
            <DivPopupBannedList>
                <div style={{margin:'10px 0'}}>
                    Encontramos os seguintes termo(s) abaixo que devem ser evitado(s):
                </div>
                <div style={{ maxHeight:'70vh',overflow:'auto'}}>
                    {mountBannedList(bannedWordList)}
                </div>
                <DivCorfirm>
                    <span>Deseja salvar o post mesmo assim ?</span>
                    <DivButtonOption>
                        <Button onClick={salvarPost}><SpanButton>Sim</SpanButton></Button>
                        <Button onClick={()=>setPopupVerifyText(false)} ><SpanButton>Não</SpanButton></Button>
                    </DivButtonOption>
                </DivCorfirm>
            </DivPopupBannedList>
        </Popup>
        <Popup open={popupVerifyTextShare} onClose={()=> setPopupVerifyTextShare(false)} contentStyle={{width:'fit-content'}} >
            <DivPopupBannedList>
                <div style={{margin:'10px 0'}}>
                    Encontramos os seguintes termo(s) abaixo que devem ser evitado(s):
                </div>
                <div style={{ maxHeight:'70vh',overflow:'auto'}}>
                    {mountBannedList(bannedWordList)}
                </div>
                <DivCorfirm>
                    <span>Deseja compartilhar o post mesmo assim ?</span>
                    <DivButtonOption>
                        <Button onClick={selectSocialMedia}><SpanButton>Sim</SpanButton></Button>
                        <Button onClick={()=>setPopupVerifyTextShare(false)} ><SpanButton>Não</SpanButton></Button>
                    </DivButtonOption>
                </DivCorfirm>
            </DivPopupBannedList>
        </Popup>
        {
            smallScreen ? <LoadScreenSmall open={smallScreen} close={setSmallScreen} /> : ''
        }
    </DivMain>)
}
